import {
	SEND_FORMS,
	SUCCESS_SEND_FORMS,
	FAIL_SEND_FORMS,
	CLEAR_FORMS,
} from '../actions';

const initialState = {
    isFetching: false,
    isError: false,
    isComplete: false,
	system_mail : 'acasds@acajp.com'
};

export default function forms(state = initialState, action) {
	let ret = Object.assign({}, state, {});
	
	switch (action.type) {
		case SEND_FORMS:
			ret.isFetching = true;
			ret.isError = false;
			return ret;
        case SUCCESS_SEND_FORMS:
        	ret.isComplete = true;
			ret.isFetching = false;
			ret.isError = false;
			return ret;
		case FAIL_SEND_FORMS:
			if(action.payload.system_mail){
				ret.system_mail = action.payload.system_mail;
			}
			ret.isComplete = true;
			ret.isFetching = false;
			ret.isError = true;
			return ret;
		case CLEAR_FORMS:
			ret.isComplete = false;
			ret.isFetching = false;
			ret.isError = false;
			return ret;
		default:
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/forms.js